export const appConfig = {
  baseUrl: process.env.REACT_APP_BASE_HREF,
  Header: {
    logo: "https://assets.airtel.in/static-assets/wirelesscoverage/airtel-logo.png",
    altText: "airtel",
  },
  SubHeader: {
    title: "Airtel Network Coverage",
    description:
      "To view network coverage at your location, simply enter your address or PIN code, or tap the current location icon. Select the ‘Coverage’ option from the displayed bars to explore detailed coverage information",
  },
  Disclaimer: {
    poweredBy: "Powered by Surecoverage",
    warningIcon: "⚠",
    shortText:
      "This map displays approximate outdoor coverage. Actual coverage may vary. Coverage isn’t guaranteed and is subject to change without notice",
    learnMoreText: "Learn More",
    popupHeading: "Important information about this coverage map",
    popupContent: [
      "These maps provide a predicted high-level approximation of wireless coverage. There are gaps in coverage that are not shown by this high-level approximation. Actual coverage may differ from map graphics and may be affected by terrain, weather, network changes, foliage, buildings, construction, signal strength, high-usage periods, customer equipment, and other factors. Airtel does not guarantee coverage.",
      "Our coverage maps are not intended to show actual customer performance on the network or future network needs or build requirements inside or outside of existing Airtel coverage areas. Coverage is subject to change without notice. Charges will be based on the location of the site receiving and transmitting the call, not the subscriber's location.",
      "These maps are subject to the ESRI map Agreement and for informational purposes only. No guarantee is made regarding their completeness or accuracy. Construction projects, traffic, or other events may cause actual conditions to differ from these results.",
    ],
  },
  ArcGISMap: {
    basemaps: {
      topo: {
        vectorUrl:
          "https://arcgis.com/sharing/rest/content/items/3e1508b05ec04dada1ae995937fd917f/resources/styles/root.json",
        thumbnail: "https://assets.airtel.in/static-assets/wirelesscoverage/topo.jpg",
        title: "Streets",
      },
      hybrid: {
        imageryUrl:
          "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer",
        vectorUrl:
          "https://arcgis.com/sharing/rest/content/items/c14ef2a973af4998a6d8cf268ff64806/resources/styles/root.json",
        thumbnail: "https://assets.airtel.in/static-assets/wirelesscoverage/hybrid.jpg",
        title: "Hybrid",
        id: "customHybrid",
      },
    },
    view: {
      center: [77.16456559470893, 28.655736155793527],
      zoom: 3,
      minZoom: 3,
      maxZoom: 15,
    },
    coverageLayers: {
      layer1: {
        id: "layer1",
        label: "2G Coverage",
        url: "https://digi-api.airtel.in/arcgis/rest/services/AirtelGIS/Coverage2g/MapServer",
        color: "#5b5bb0",
      },
      layer2: {
        id: "layer2",
        label: "4G Coverage",
        url: "https://digi-api.airtel.in/arcgis/rest/services/AirtelGIS/Coverage4g/MapServer",
        color: "#800080",
      },
      layer3: {
        id: "layer3",
        label: "5G Coverage",
        url: "https://digi-api.airtel.in/arcgis/rest/services/AirtelGIS/Coverage5g/MapServer",
        color: "#dddd41",
      },
    },
    search: {
      placeholder: "Find address or place",
    },
    coverageDateService:
      "https://digi-api.airtel.in/arcgis/rest/services/AirtelGIS/WirelessCoverageDate/MapServer/0",
  },
  Popup: {
    closeButtonText: "Close",
  },
  RefreshPageComponent: {
    title: "Home",
    icon: "https://assets.airtel.in/static-assets/wirelesscoverage/home.png",
    altText: "airtel",
  },
  App: {
    infoPopup: {
      heading: "Help",
      title: "Airtel Coverage Map",
      description:
        "Discover the strength of Airtel’s 2G,4G and 5G networks with our interactive Coverage Map. Built using advanced radio frequency prediction models, this map gives you a reliable view of our expected outdoor network coverage across India.",
      whatMapShows:
        "Coverage areas are based on a Reference Signal Received Power (RSRP) threshold of -110 (4G&5G) and -95 (2G) in accordance with TRAI guidelines. While the map displays outdoor signal coverage, it doesn’t reflect indoor availability. Actual coverage may vary due to local geography, buildings, or other surroundings. In some cases, you might even experience signal beyond the mapped zones.",
      howToUse: [
        "Use the search bar to find coverage at any address or location.",
        "Move around the map using your mouse or arrow keys.",
        "Zoom in or out using the ‘+’ or ‘–’ buttons.",
      ],
      colorInfo: [
        "Blue areas show Airtel’s 2G coverage",
        "Purple areas show Airtel’s 4G coverage",
        "Yellow areas show Airtel’s 5G coverage",
      ],
      footerText:
        "By default, the map shows a combined view of 2G, 4G and 5G networks. Want to see only one? Use the toggle tabs at the map top-center to filter by network type.",
      closingText:
        "Explore the map now and stay connected with India’s trusted network—Airtel.",
    },
    icons: {
      info: "https://assets.airtel.in/static-assets/wirelesscoverage/i.png",
      feedback: "https://assets.airtel.in/static-assets/wirelesscoverage/shareFeedback.png",
    },
  },
};
